import React from 'react';
import axios from 'axios';
import cryptoJs from 'crypto-js';
import { useAuth0 } from '@auth0/auth0-react';
import { useAuthContext } from '@asgardeo/auth-react';

export const ComponentDebugModule = () => {
  const { getAccessTokenSilently } = useAuth0();
  const { state, getAccessToken, signOut } = useAuthContext();

  const getPublishers = async () => {
    const t = await getAccessTokenSilently();
    const t2 = await getAccessToken();
    const encodedValues = cryptoJs.AES.encrypt(
      JSON.stringify({ apiKey: t2 }),
      process.env.REACT_APP_ENCRYPTION_SECRET as string
    ).toString();
    return await axios
      .post(
        `${process.env.REACT_APP_REGISTRY_API}/user/publishers`,
        { payload: encodedValues },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${t}`,
          },
        }
      )
      .then((response) => {
        console.log(response.data);
      })
      .catch((error) => {
        console.error('Error getting publishers:', error);
      });
  };

  return (
    <div>
      <button onClick={getPublishers}>Click Me</button>
      {state.isAuthenticated && (
        <button onClick={() => signOut()}>Sign out</button>
      )}
    </div>
  );
};
